<template>
  <div
    class="bg-[rgb(15,23,42)] shadow-lg py-3 sticky top-0 z-50 text-black"
    @contextmenu="handleRightClick"
  >
    <div class="container mx-auto max-w-[1200px] px-4">
      <div class="flex items-center justify-between">
        <!-- Logo -->
        <!-- <div>
          <img src="@/assets/new/moun.png" alt="Logo" class="w-40 py-4" />
        </div> -->
        <router-link
          :to="{ name: 'StudentHome' }"
          class="brand w-nav-brand w--current flex items-center"
        >
          <img
            :src="logo_image"
            alt="Logo"
            class="w-20 sm:w-24 md:w-32 lg:w-36 xl:w-40 py-4 object-contain"
          />
        </router-link>

        <!-- Desktop Menu -->
        <div class="flex items-center gap-8">
          <!-- <div
            class="text-[#0085DB] px-2 font-bold hidden md:block"
            v-if="this.userInfo"
          >
            {{
              this.userInfo.user.permission.charAt(0).toUpperCase() +
              this.userInfo.user.permission.slice(1)
            }}
            ({{ this.userInfo.program }})
          </div> -->
          <div class="hidden lg:flex items-center gap-10">
            <template v-for="link in navLinks" :key="link.route">
              <router-link :to="{ name: link.route }" class="relative group">
                <div class="px-3 py-2">
                  <span
                    class="text-sm font-medium transition-colors duration-200"
                    :class="{
                      'text-blue-400': $route.name === link.route,
                      'text-gray-300 hover:text-white':
                        $route.name !== link.route,
                    }"
                  >
                    {{ link.label }}
                  </span>
                  <span
                    class="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-blue-400 to-cyan-400 transition-all duration-300 group-hover:w-full"
                    :class="{ 'w-full': $route.name === link.route }"
                  ></span>
                </div>
              </router-link>
            </template>
          </div>
          <div class="hidden">
            <div
              class="flex items-center gap-2 rounded-lg border border-amber-400/20 bg-gray-900/80 px-2.5 py-1.5 backdrop-blur-md shadow-sm hover:border-amber-400/40 transition-all"
            >
              <!-- Coin -->
              <svg
                width="32"
                height="32"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <!-- dark halo (matches the gray bg in image) -->
                <circle cx="24" cy="24" r="23" fill="#78716C" opacity=".18" />
                <!-- amber coin body -->
                <circle cx="24" cy="24" r="20" fill="#F59E0B" />
                <!-- bright rim -->
                <circle
                  cx="24"
                  cy="24"
                  r="20"
                  fill="none"
                  stroke="#FCD34D"
                  stroke-width="1.2"
                  opacity=".6"
                />
                <!-- inner orange glow -->
                <circle cx="24" cy="24" r="15" fill="#F97316" opacity=".35" />
                <!-- bolt -->
                <path
                  d="M26 14 L18 25 L23.5 25 L22 34 L30 23 L24.5 23 Z"
                  fill="white"
                />
              </svg>
              <!-- Text -->
              <div class="leading-none">
                <p
                  class="text-[9px] uppercase tracking-wider text-gray-400 font-semibold"
                >
                  Points
                </p>
                <p class="text-sm font-bold text-amber-300">
                  3,250
                  <span class="text-[10px] text-gray-400 font-medium">pts</span>
                </p>
              </div>
            </div>
          </div>
          <!-- Message -->

          <div class="relative dropdown-container">
            <div class="relative" @click="MenuToggle('messages')">
              <p
                class="bg-white flex items-center justify-center text-primary !w-[25px] !h-[25px] text-xs rounded-full absolute -top-6 -right-5"
              >
                {{ messageCount || 0 }}
              </p>

              <img
                src="@/assets/new/chat.svg"
                width="20"
                height="20"
                class="cursor-pointer"
              />
            </div>
            <div
              v-if="toggleMenuName == 'messages'"
              class="absolute right-[-70px] lg:right-0 top-14 lg:top-10 w-64 z-10 bg-white rounded-2xl shadow-lg p-4"
            >
              <div
                class="font-bold text-sm pb-3 flex items-center gap-2 text-black"
              >
                Messages
                <p
                  class="bg-primary flex items-center justify-center text-white !w-[25px] !h-[25px] text-xs rounded-full"
                  v-if="messageCount != 0"
                >
                  {{ messageCount }}
                </p>
              </div>

              <div class="flex flex-col gap-2">
                <div v-if="messageList.length != 0" class="flex flex-col gap-2">
                  <router-link
                    :to="{ name: 'StudentMessagesList' }"
                    class="flex flex-col border gap-1 py-2 px-4 rounded-lg hover:bg-gray-100"
                    :class="{
                      'bg-white border-blue-500 shadow-md ring-1 ring-blue-100 hover:bg-blue-50':
                        !message.readed,
                      'bg-white border-gray-300 hover:bg-gray-100 hover:border-gray-300':
                        message.readed,
                    }"
                    v-for="(message, index) in messageList.slice(0, 3)"
                    :key="message.id || index"
                  >
                    <h4
                      class="text-xs truncate transition-colors uppercase font-bold"
                      :class="
                        !message.readed
                          ? 'font-bold text-slate-900'
                          : 'font-medium text-slate-600'
                      "
                    >
                      {{ message.owner_display_name || "NA" }}
                    </h4>
                    <div
                      class="text-[12px] tracking-tight flex w-full"
                      :class="
                        !message.readed
                          ? 'text-slate-700 font-medium'
                          : 'text-slate-500 font-normal'
                      "
                    >
                      <p class="line-clamp-1 w-full">
                        {{ message.course_title || "NA" }}
                      </p>
                    </div>
                    <p
                      class="text-xs line-clamp-1"
                      :class="
                        !message.readed
                          ? 'text-slate-700 font-medium'
                          : 'text-slate-500 font-normal'
                      "
                    >
                      {{ message.text || "No preview available..." }}
                    </p>
                    <p
                      class="text-xs"
                      :class="
                        !message.readed
                          ? 'text-slate-700 font-medium'
                          : 'text-slate-500 font-normal'
                      "
                    >
                      {{ formatDateTime(message.created_at) }}
                    </p>
                  </router-link>

                  <router-link
                    :to="{ name: 'StudentMessagesList' }"
                    v-if="messageList.length > 3"
                    class="text-blue-600 hover:text-blue-700 font-bold text-xs py-2 text-end"
                  >
                    See More
                  </router-link>
                </div>
                <router-link
                  :to="{ name: 'StudentMessagesList' }"
                  v-if="this.messageList.length == 0"
                  class="flex text-sm flex-col border gap-1 py-2 px-4 rounded-lg text-black"
                  >No Data Found</router-link
                >
              </div>
            </div>
          </div>
          <!-- Notifications -->
          <div class="relative dropdown-container">
            <div class="relative" @click="MenuToggle('notification')">
              <p
                class="bg-white flex items-center justify-center text-primary !w-[25px] !h-[25px] text-xs rounded-full absolute -top-5 -right-5"
              >
                {{ notificationData?.unread_count || "-" }}
              </p>

              <img
                src="@/assets/notification.png"
                width="24"
                height="24"
                class="cursor-pointer"
              />
            </div>

            <div
              v-if="toggleMenuName === 'notification'"
              class="absolute right-[-70px] lg:right-0 top-14 lg:top-10 w-64 z-10 bg-white rounded-2xl shadow-lg p-4"
            >
              <!-- Header -->
              <div
                class="font-bold text-sm pb-3 flex items-center gap-2 text-black"
              >
                Notifications

                <!-- Unread Count -->
                <p
                  v-if="notificationData?.unread_count > 0"
                  class="bg-primary flex items-center justify-center text-white !w-[25px] !h-[25px] text-xs rounded-full"
                >
                  {{ notificationData.unread_count }}
                </p>
              </div>

              <div class="flex flex-col gap-2">
                <!-- Notification List -->
                <div
                  v-if="notificationData?.data?.length > 0"
                  class="flex flex-col gap-2"
                >
                  <router-link
                    v-for="notifi in notificationData.data.slice(0, 3)"
                    :key="notifi.id"
                    :to="{ name: 'StudentNotifications' }"
                    class="flex flex-col border gap-1 py-2 px-4 rounded-lg hover:bg-slate-100"
                    :class="
                      !notifi.read
                        ? 'bg-white border-blue-400 shadow-sm ring-1 ring-blue-50 hover:bg-blue-50'
                        : 'bg-slate-50 border-slate-200 opacity-80 hover:opacity-100 hover:bg-white hover:border-slate-300'
                    "
                  >
                    <div class="flex justify-between items-start">
                      <!-- Topic -->
                      <p
                        class="font-bold text-xs truncate"
                        :class="
                          !notifi.read ? 'text-gray-900' : 'text-gray-500'
                        "
                      >
                        {{ notifi.topic }}
                      </p>

                      <!-- Unread Dot -->
                      <span
                        v-if="!notifi.read"
                        class="flex h-2 w-2 rounded-full bg-blue-500"
                      ></span>
                    </div>

                    <!-- Date -->
                    <p class="text-[10px] text-gray-400">
                      {{ formatDate(notifi.created_at) }}
                    </p>
                  </router-link>

                  <!-- See More -->
                  <router-link
                    v-if="notificationData.data.length > 3"
                    :to="{ name: 'StudentNotifications' }"
                    class="text-blue-600 hover:text-blue-800 hover:underline font-bold text-xs py-2 text-center transition-all"
                  >
                    See More
                  </router-link>
                </div>

                <!-- No Data -->
                <router-link
                  v-else
                  :to="{ name: 'StudentNotifications' }"
                  class="flex text-xs flex-col border gap-1 py-2 px-4 rounded-lg text-black"
                >
                  No Data Found
                </router-link>
              </div>
            </div>
          </div>

          <!-- Profile Dropdown -->
          <div class="relative z-50 dropdown-container">
            <div
              @click="MenuToggle('profile')"
              class="flex items-center cursor-pointer"
            >
              <!-- {{ userInfo.image }}  -->

              <img
                v-if="userInfo && userInfo.image && userInfo.image != null"
                :src="userInfo.image"
                class="w-10 h-10 rounded-full border-2 border-white"
              />
              <img
                v-else
                src="@/assets/new/image.png"
                class="w-10 h-10 rounded-full border-2 border-white"
              />

              <!-- <img
                v-if="isAuthenticated && profileInfo != null && profileInfo.data.profile"
                :src="profileInfo.data.profile"
                class="w-10 h-10 rounded-full border-2 border-white"
              />
              <img
                v-else
                src="@/assets/new/image.png"
                class="w-10 h-10 rounded-full border-2 border-white"
              /> -->
            </div>

            <div
              v-if="toggleMenuName == 'profile'"
              class="absolute right-0 mt-2 w-48 bg-white rounded-2xl shadow-lg"
            >
              <router-link
                :to="{ name: 'StudentUserProfile' }"
                class="flex gap-2 text-xs py-3 px-4 cursor-pointer hover:bg-slate-200 hover:rounded-t-2xl"
              >
                <img
                  src="@/assets/new/profile.png"
                  class="w-5 h-5"
                  alt="Profile"
                />

                <div
                  class="text-xs font-medium text-[#ADADAD] flex flex-col gap-1 text-wrap"
                >
                  <span
                    class="font-semibold"
                    :class="{
                      'text-[#0085db]': $route.name === 'StudentUserProfile',
                      'text-gray-800': $route.name !== 'StudentUserProfile',
                    }"
                    >Profile</span
                  >
                  <span class="break-all text-black/50">{{
                    this.userInfo?.user?.display_name
                  }}</span>
                  <span class="break-all text-black/50">
                    <span class="text-[13px]">PRN :</span>
                    {{ this.userInfo?.prn_number || "NA" }}</span
                  >
                </div>
              </router-link>

              <hr />

              <router-link
                v-if="checkinTheList('Timetable')"
                :to="{ name: 'StudentTimeTable' }"
                class="flex items-center gap-2 text-xs py-3 px-4 cursor-pointer hover:bg-slate-200 hidden"
                :class="{
                  'text-[#0085db]': $route.name === 'StudentTimeTable',
                  'text-gray-800': $route.name !== 'StudentTimeTable',
                }"
                >TimeTable</router-link
              >

              <!-- <hr v-if="checkinTheList('Timetable')" /> -->

              <router-link
                v-if="checkinTheList('Attendance')"
                :to="{ name: 'StudentAttendanceList' }"
                class="flex items-center gap-2 text-xs py-3 px-4 cursor-pointer hover:bg-slate-200 hidden"
                :class="{
                  'text-[#0085db]': $route.name === 'StudentAttendanceList',
                  'text-gray-800': $route.name !== 'StudentAttendanceList',
                }"
                >Attendance</router-link
              >

              <!-- <hr v-if="checkinTheList('Attendance')" /> -->

              <router-link
                v-if="checkinTheList('Feedback')"
                :to="{ name: 'StudentFeedBack' }"
                class="flex items-center gap-2 text-xs py-3 px-4 cursor-pointer hover:bg-slate-200 hidden"
                :class="{
                  'text-[#0085db]': $route.name === 'StudentFeedBack',
                  'text-gray-800': $route.name !== 'StudentFeedBack',
                }"
                >Feedback</router-link
              >

              <!-- <hr  v-if="checkinTheList('Feedback')" /> -->

              <!--            
                <router-link
                  :to="{ name: 'StudentGrade' }"
                  class="flex items-center gap-2 text-xs py-3 px-4 cursor-pointer"
                  :class="{
                    'text-[#0085db]': $route.name === 'StudentGrade',
                    'text-gray-800': $route.name !== 'StudentGrade',
                  }"
                  >Results</router-link
                >
             

              <hr /> -->

              <router-link
                :to="{ name: 'StudentTaskList' }"
                class="flex items-center gap-2 text-xs py-3 px-4 cursor-pointer hover:bg-slate-200"
                :class="{
                  'text-[#0085db]': $route.name === 'StudentTaskList',
                  'text-gray-800': $route.name !== 'StudentTaskList',
                }"
                >My Task</router-link
              >

              <hr />

              <router-link
                :to="{ name: 'StudentSyallbusView' }"
                class="flex items-center gap-2 text-xs py-3 px-4 cursor-pointer hover:bg-slate-200"
                :class="{
                  'text-[#0085db]': $route.name === 'StudentSyallbusView',
                  'text-gray-800': $route.name !== 'StudentSyallbusView',
                }"
                >User Instructions</router-link
              >

              <hr />
              <!-- <div class="space-y-1">
                <div class="flex items-center gap-2 py-3 px-4 cursor-pointer">
                  <router-link
                    :to="{ name: 'CompleteCourse' }"
                    class="text-xs font-medium"
                    :class="{
                      'text-[#0085db]': $route.name === 'CompleteCourse',
                      'text-gray-800': $route.name !== 'CompleteCourse',
                    }"
                    >Complete Course</router-link
                  >
                </div>
              </div>
              <hr /> -->

              <!-- <router-link
                    :to="{ name: 'StudentSupportSystem' }"
                    class="text-xs font-medium"
                    :class="{
                      'text-[#0085db]': $route.name === 'StudentSupportSystem',
                      'text-gray-800': $route.name !== 'StudentSupportSystem',
                    }"
                    >Support System</router-link
                  >  -->
              <!-- <a
                href="https://sis.allianceonline.edu.in/"
                class="flex items-center gap-2 py-3 px-4 cursor-pointer text-xs hover:bg-slate-200"
                :class="{
                  'text-[#0085db]': $route.name === 'StudentSupportSystem',
                  'text-gray-800': $route.name !== 'StudentSupportSystem',
                }"
                target="blank"
              >
                Tickets</a
              >

              <hr />
              <a
                href="https://au-exams.galecta.com"
                class="flex items-center gap-2 py-3 px-4 cursor-pointer text-xs hover:bg-slate-200"
                :class="{
                  'text-[#0085db]': $route.name === 'StudentSupportSystem',
                  'text-gray-800': $route.name !== 'StudentSupportSystem',
                }"
                target="blank"
              >
                Semester Exam</a
              > -->

              <!-- <hr /> -->

              <router-link
                :to="{ name: 'HomeHelpvue' }"
                class="flex items-center gap-2 text-xs py-3 px-4 cursor-pointer hover:bg-slate-200 hidden"
                :class="{
                  'text-[#0085db]': $route.name === 'HomeHelpvue',
                  'text-gray-800': $route.name !== 'HomeHelpvue',
                }"
              >
                Help</router-link
              >
              <hr />
              <div class="space-y-1">
                <!-- <div class="flex items-center gap-2 py-3 px-4 cursor-pointer ">
                  <img src="@/assets/newd/solar_settings-linear.png" class="w-5 h-5" alt="Settings Icon">
                  <router-link :to="{ name: 'StudentHome' }"
                    class="text-xs font-medium text-gray-800">Settings</router-link>
                </div>
                <hr class="border-gray-300" />

                <div class="flex items-center gap-2 py-3 px-4 cursor-pointer ">
                  <img src="@/assets/newd/material-symbols-light_feedback-outline-rounded.png" class="w-5 h-5"
                    alt="Feedback Icon">
                  <router-link :to="{ name: 'StudentHome' }"
                    class="text-xs font-medium text-gray-800">Feedback</router-link>
                </div>
                <hr class="border-gray-300" /> -->

                <!-- <div class="flex items-center gap-2 py-3 px-4 cursor-pointer ">
                  <img src="@/assets/newd/fluent_person-ribbon-20-regular.png" class="w-5 h-5" alt="Attendance Icon">
                  <router-link :to="{ name: 'StudentHome' }"
                    class="text-xs font-medium text-gray-800">Attendance</router-link>
                </div>
                <hr class="border-gray-300" />

                <div class="flex items-center gap-2 py-3 px-4 cursor-pointer ">
                  <img src="@/assets/newd/bx_support.png" class="w-5 h-5" alt="Support Icon">
                  <router-link :to="{ name: 'StudentHome' }"
                    class="text-xs font-medium text-gray-800">Support</router-link>
                </div> -->
              </div>

              <div
                @click="
                  LogOutModal = true;
                  toggleMenuName = '';
                "
                class="flex items-center gap-2 py-3 px-4 cursor-pointer text-red-500 font-semibold text-xs hover:bg-slate-200 hover:rounded-b-2xl"
              >
                <img src="@/assets/new/logout.png" width="15" height="15" />
                Logout
              </div>
            </div>
          </div>
          <!-- Mobile Menu Toggle -->
          <div class="lg:hidden relative dropdown-container">
            <button
              @click="MenuToggle('mobilemenu')"
              class="text-white focus:outline-none"
            >
              <svg
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                ></path>
              </svg>
            </button>

            <!-- mobile menu -->
            <div
              v-if="toggleMenuName == 'mobilemenu'"
              class="absolute right-6 top-20 z-50 bg-white rounded-2xl shadow-lg lg:hidden"
              style="width: 180px"
            >
              <router-link
                :to="{ name: 'StudentHome' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
                :class="{
                  'text-[#0085db]': $route.name === 'StudentHome',
                  'text-black': $route.name !== 'StudentHome',
                }"
              >
                Home
              </router-link>
              <hr />
              <router-link
                :to="{ name: 'StudentMyCourse' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
                :class="{
                  'text-[#0085db]': $route.name === 'StudentMyCourse',
                  'text-black': $route.name !== 'StudentMyCourse',
                }"
              >
                My Courses
              </router-link>
              <hr />
              <!-- <router-link
                :to="{ name: 'StudentCommunity' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
                :class="{
                  'text-[#0085db]': $route.name === 'StudentCommunity',
                  'text-black': $route.name !== 'StudentCommunity',
                }"
              >
                Community
              </router-link>
              <hr />
              <router-link
                :to="{ name: 'StudentCurriculum' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
                :class="{
                  'text-[#0085db]': $route.name === 'StudentCurriculum',
                  'text-black': $route.name !== 'StudentCurriculum',
                }"
              >
                Curriculum
              </router-link>
              <hr /> -->
              <router-link
                :to="{ name: 'StudentBlogs' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
                :class="{
                  'text-[#0085db]': $route.name === 'StudentBlogs',
                  'text-black': $route.name !== 'StudentBlogs',
                }"
              >
                Blogs
              </router-link>
              <hr />
              <router-link
                :to="{ name: 'CompleteCourse' }"
                class="text-xs font-medium flex items-center gap-2 py-3 px-6 cursor-pointer"
                :class="{
                  'text-[#0085db]': $route.name === 'CompleteCourse',
                  'text-black': $route.name !== 'CompleteCourse',
                }"
              >
                Complete Course
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Logout
      v-if="LogOutModal"
      @logOut="logOut"
      @cancel="LogOutModal = !LogOutModal"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import axios from "axios";
import Logout from "@/components/Logout.vue";
import rightClickProtection from "@/mixins/rightClickProtection";
export default {
  mixins: [rightClickProtection],
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "userInfo",
      "notificationCount",
      "permissionList",
      "notificationData",
      "messageCount",
    ]),
  },

  data() {
    return {
      logo_image: require(`${process.env.VUE_APP_COMS_LOGO}`),
      toggleMenuName: null,
      profileInfo: null,
      LogOutModal: false,
      notificationList: [],
      messageList: [],
      navLinks: [
        { label: "Home", route: "StudentHome" },
        { label: "My Courses", route: "StudentMyCourse" },
        { label: "Blogs", route: "StudentBlogs" },
        { label: "Complete Course", route: "CompleteCourse" },
      ],
      // messagecount: null,
    };
  },

  components: {
    Logout,
  },

  created() {
    this.getNotifications();
    // this.getMessages();

    if (this.userInfo) {
      let token = this.userInfo.token_key;
      let slug_id = this.userInfo.slug_id;
      axios
        .get(
          `${process.env.VUE_APP_API}/profile_detail/?Key=${token}&format=json`,
        )
        .then((response) => (this.profileInfo = response.data));
    } else {
      console.log("Not Login");
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    this.$store.dispatch("connectMessageSocket");

    this.$store.commit("SET_ON_NEW_MESSAGE", () => {
      this.loadMessages(this.currentPage);
    });

    this.loadMessages();
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {
    ...mapActions(["logOutUser"]),
    ...mapMutations(["notifyCount"]),
    async loadMessages(page = 1) {
      if (!this.userInfo) return;

      const data = await this.$store.dispatch("fetchMessageList", {
        userId: this.userInfo.user.id,
        token: this.userInfo.token_key,
        page,
      });

      this.messageList = data.data;
    },
    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "numeric",
        year: "numeric",
      });
    },
    formatDateTime(dateString) {
      const date = new Date(dateString);
      const now = new Date();

      const isSameDate =
        date.getDate() === now.getDate() &&
        date.getMonth() === now.getMonth() &&
        date.getFullYear() === now.getFullYear();

      if (isSameDate) {
        // Show only time if today
        return date.toLocaleTimeString("en-IN", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      } else {
        // Show full date and time if not today
        return date.toLocaleString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      }
    },
    // checkinTheList(feature) {
    //   let check = this.permissionList.find((x) => x === feature);
    //   if (check != undefined) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    checkinTheList(feature) {
      if (
        !Array.isArray(this.permissionList) ||
        this.permissionList.length === 0
      ) {
        return true;
      }

      return this.permissionList.includes(feature);
    },

    async getNotifications() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/notifications/${this.userInfo.user.id}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response) {
            this.notificationList = response.data.data.data;
          }
        });
    },

    MenuToggle(name) {
      if (this.toggleMenuName == name) {
        this.toggleMenuName = null;
      } else {
        this.toggleMenuName = name;
      }
    },

    async logOut() {
      await this.logOutUser();
      this.LogOutModal = false;
      this.$router.push({
        name: "Login",
      });
    },
    handleClickOutside(event) {
      if (!event.target.closest(".dropdown-container")) {
        this.toggleMenuName = null;
      }
    },
    // async getMessages() {
    //   await axios
    //     .get(
    //       `${process.env.VUE_APP_API}/message-course-overall-details/?client__id=${this.userInfo.user.id}&Key=${this.userInfo.token_key}`
    //     )
    //     .then((response) => {
    //       if (response) {
    //         this.messageList = response.data.data.data;
    //         this.messagecount = response.data.count;
    //       }
    //     });
    // },
  },
};
</script>

<style></style>
